import type { NextPage } from "next";
import Head from "next/head";
import FAQ from "@components/FAQ/FAQ";
import Breadcrumbs, { BREADCRUMBS } from "@components/Various/Seo/Breadcrumbs";

const FAQPage: NextPage = () => {
  return (
    <div className="">
      <Head>
        <title>FAQ | Smarketer Jobs</title>
      </Head>

      <Breadcrumbs
        breadcrumbs={[
          BREADCRUMBS.HOME,
          {
            title: "FAQ",
            url: "/faq",
          },
        ]}
      />
      <FAQ />

      {/* <CallUs />
      <FinalCTA /> */}
    </div>
  );
};

export { getStaticProps } from "@lib/utils/translationsStaticProps";
export default FAQPage;
